import { Button, Card, Form, Input } from 'antd'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions } from '../../../../store/reducers/admin.reducer'
import { openNotificationWithIcon } from '../../../../utils/notification.helper'

const ResetOtpCard = ({ resetUserOtp }) => {
    const [form] = Form.useForm()
    const [resetLoading, setResetLoading] = useState(false)

    const handleResetOtp = async () => {
        setResetLoading(true)

        try {
            const data = await form.validateFields()

            await resetUserOtp(data.email)
        } catch (error) {
            openNotificationWithIcon('error', error.response.data.detail)
        } finally {
            openNotificationWithIcon('success', 'OTP is successfully reset!')
            setResetLoading(false)
        }
    }

    return (
        <Card title='Reset OTP' bordered={false} className='mb-32'>
            <Form
                form={form}
                name='impersonate-form'
                onFinish={handleResetOtp}
                layout='vertical'
                requiredMark={false}
                validateTrigger={['onBlur', 'onSubmit']}
            >
                <Form.Item
                    label='Email'
                    name='email'
                    rules={[
                        { required: true, message: "Please, input user's email" },
                        { type: 'email', message: 'Please, input valid email' },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item>
                    <Button type='primary' htmlType='submit' block loading={resetLoading}>
                        Reset
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

const mapState = ({ auth }) => {
    return {
        user: auth.user,
    }
}

const mapDispatch = dispatch => {
    return {
        resetUserOtp(data) {
            return dispatch(actions.resetUserOtp(data))
        },
    }
}

export default connect(mapState, mapDispatch)(ResetOtpCard)
